import { render, staticRenderFns } from "./closeBalanceList.vue?vue&type=template&id=25552933&"
import script from "./closeBalanceList.vue?vue&type=script&lang=js&"
export * from "./closeBalanceList.vue?vue&type=script&lang=js&"
import style0 from "./closeBalanceList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports